import React from 'react';
import Tab from 'react-bootstrap/Tab';

function PrivacyTabContent({ data }) {
    return (
        <Tab.Pane eventKey={data.eventKey}>
            <div className='content'>
                <div className='heading'>
                    <h2>{data.heading}</h2>
                </div>
                <p>{data.para1}</p>
                <p>{data.para2}</p>
                <ul>
                    {data?.lists?.map((item, index) => (
                        <li key={index}>{item.listname}</li>
                    ))}
                </ul>
              
            </div>
        </Tab.Pane>
    )
}

export default PrivacyTabContent;
